import { Skeleton } from 'antd';
import { Row } from 'farmhub-ui-core';

import { Img, InfoCard, Wrapper, WrapperText } from './styles';

const AccountInformationItemSkeleton = () => (
  <Wrapper>
    <Row justifyContent="space-between">
      <InfoCard>
        <Img>
          <Skeleton.Avatar size="large" />
        </Img>
        <WrapperText>
          <Skeleton.Input size="small" style={{ width: 250 }} />
          <Skeleton.Input size="small" style={{ width: 250 }} />
        </WrapperText>
      </InfoCard>
    </Row>
  </Wrapper>
);

export default AccountInformationItemSkeleton;
